import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-couponOwnership",
  "use": "icon-couponOwnership-usage",
  "viewBox": "0 0 138 21",
  "content": "<symbol viewBox=\"0 0 138 21\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-couponOwnership\">\n<path d=\"M0 21V0H138L132.579 21H0Z\" fill=\"#FBEBDF\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol